import { v4 as uuidv4 } from 'uuid';

export function SellerAddToCart(props = {}, childrenComponents = [], blocks = []) {
	return {
		componentName: 'SellerAddToCart',
		componentId: uuidv4(),
		title: '',
		props: Object.assign(
			{
				isOneClickBuy: false,
			},
			props,
		),
		childrenComponents,
		blocks,
	};
}
